import { Helmet } from 'react-helmet-async';

/**
 * Component to set page title dynamically using React Helmet
 * @param {string} title - The page-specific title (e.g., "Home", "About", "Insights")
 * @param {string} suffix - Optional suffix (default: "Ashbourne Law")
 * @returns {JSX.Element} Helmet component with title
 */
const PageTitle = ({ title, suffix = 'Ashbourne Law' }) => {
  const fullTitle = title ? `${title} | ${suffix}` : suffix;
  
  return (
    <Helmet>
      <title>{fullTitle}</title>
    </Helmet>
  );
};

export default PageTitle;
